import React, { useState, useEffect } from 'react'; 
import { Container, Nav, Navbar, Button, NavDropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaTachometerAlt, FaTags, FaBox, FaBlog, FaBullhorn, FaClipboardList, FaWarehouse, FaChartLine, FaTruckLoading, FaTruckMoving, FaCogs, FaBoxes, FaReceipt, FaChartPie } from "react-icons/fa";

// Imported pages
import AnalyticsDashboard from './AnalyticsDashboard';
import RawMaterialReceivingNote from './RawMaterialReceivingNote';
import StoreIssueVoucher from './StoreIssueVoucher';
import RawMaterialStockManagement from './RawMaterialStockManagement';

import ProfileEditPage from './ProfileEditPage';
import RawMaterialRequest from './RawMaterialRequest';
function StoreKeeperDashboardLayout() {
    const [activeMenu, setActiveMenu] = useState("dashboard-page");
    const [adminData, setAdminData] = useState(null);
    const navigate = useNavigate();
  
    
    useEffect(() => {
        const fetchAdminData = async () => {
            try {
                const response = await axios.get('https://agpipefitting.org.et/api/admin/profile', {
                    headers: { 
                        Authorization: `Bearer ${localStorage.getItem('adminToken')}`
                    }
                });
                setAdminData(response.data);
                localStorage.setItem('admin', JSON.stringify(response.data));
            } catch (error) {
                console.error("Error fetching admin data", error);
                localStorage.removeItem('adminToken');
                navigate('/admin-login');
            }
        };
       
        // Check existing data in localStorage
        const storedAdmin = localStorage.getItem('admin');
        if (storedAdmin) {
            setAdminData(JSON.parse(storedAdmin));
        } else {
            fetchAdminData();
        }
    }, [navigate]);
  
    // Handle profile updates from child component
    const handleProfileUpdate = (updatedData) => {
        setAdminData(updatedData);
        localStorage.setItem('admin', JSON.stringify(updatedData));
    };

   
    const renderContent = () => {
        switch (activeMenu) {    
             case "edit-profile":
                              return <ProfileEditPage 
                                       adminData={adminData} 
                                       onProfileUpdate={handleProfileUpdate} 
                                     />;     
            case "receiving-note":
                return <RawMaterialReceivingNote />;
                
            case "issue-voucher":
                return <StoreIssueVoucher />;
            case "raw_stock":
                return <RawMaterialStockManagement />;
            case "/admin/analytics":
                return <AnalyticsDashboard />;

               

                    case "stock":
                        return <RawMaterialRequest />;
            default:
                return <RawMaterialReceivingNote />; // Fallback default
        }
    };

    

    const handleLogout = () => {
        localStorage.removeItem('isAdminLoggedIn');
        navigate('/admin-login');
    };

    const iconStyles = {
        dashboard: { color: "#ff5733" }, // Red
        categories: { color: "#33ff57" }, // Green
        products: { color: "#3357ff" }, // Blue
        blogs: { color: "#ff33a8" }, // Pink
        banners: { color: "#ffa833" }, // Orange
        requests: { color: "#8e44ad" }, // Purple
        stock: { color: "#2c3e50" }, // Dark Grey
        sales: { color: "#e74c3c" }, // Coral Red
        receivingGoods: { color: "#16a085" }, // Teal
        deliveryGoods: { color: "#2980b9" }, // Light Blue
        rawMaterials: { color: "#d35400" }, // Dark Orange
        materialsIssue: { color: "#c0392b" }, // Dark Red
        materialsStock: { color: "#7f8c8d" }, // Grey
        viewReceipt: { color: "#f39c12" }, // Yellow-Orange
        analytics: { color: "#9b59b6" }, // Purple
    };

    return (
        <div className="d-flex">
            {/* Sidebar */}
            <div className="bg-dark text-white vh-100 p-3" style={{ width: '250px', position: 'fixed' }}>
                <Nav className="flex-column">
                    <Nav.Link className={`text-white ${activeMenu === "receiving-note" ? "active" : ""}`}
                        onClick={() => setActiveMenu("receiving-note")}>
                     <FaCogs style={iconStyles.rawMaterials} /> Raw Materials
                    </Nav.Link>

                    <Nav.Link className={`text-white ${activeMenu === "issue-voucher" ? "active" : ""}`}
                        onClick={() => setActiveMenu("issue-voucher")}>
                        <FaBoxes style={iconStyles.materialsIssue} /> Materials Issue
                    </Nav.Link>

                    <Nav.Link className={`text-white ${activeMenu === "raw_stock" ? "active" : ""}`}
                        onClick={() => setActiveMenu("raw_stock")}>
                        <FaWarehouse style={iconStyles.materialsStock} /> Materials Stock 
                    </Nav.Link>

                    <Nav.Link className={`text-white ${activeMenu === "stock" ? "active" : ""}`}
                        onClick={() => setActiveMenu("stock")}>
                       Requests
                    </Nav.Link>

                    <Nav.Link className={`text-white ${activeMenu === "material-requests" ? "active" : ""}`}
                        onClick={() => setActiveMenu("material-requests")}>
                       Approve Requests
                    </Nav.Link>

                </Nav>
            </div>

            {/* Main Content */}
            <div className="flex-grow-1" style={{ marginLeft: '250px', padding: '20px' }}>
                      {/* Top Navigation Bar */}
                      <Navbar bg="success" expand="lg" className="shadow-sm mb-4 py-3 px-3">
                          <Navbar.Brand className="fw-bold text-white">
                              {adminData?.role ? `${adminData.role} Dashboard` : 'Admin Dashboard'}
                          </Navbar.Brand>
                          
                          <Nav className="ms-auto align-items-center">
                              <Navbar.Text className="text-white me-3">
                                  <i className="bi bi-person-circle me-2"></i>
                                  <strong>{adminData?.name || 'Loading...'}</strong>
                              </Navbar.Text>
      
                              <NavDropdown 
                                  title={<span className="text-white">Account</span>} 
                                  id="account-dropdown"
                                  align="end"
                              >
                                  <NavDropdown.Item onClick={() => setActiveMenu("edit-profile")}>
                                      Edit Profile
                                  </NavDropdown.Item>
                                  <NavDropdown.Divider />
                                  <NavDropdown.Item onClick={handleLogout}>
                                      Logout
                                  </NavDropdown.Item>
                              </NavDropdown>
                          </Nav>
                      </Navbar>
      
                      {/* Dynamic Content Area */}
                      <div className="bg-white shadow-sm rounded-3 p-4" style={{ minHeight: 'calc(100vh - 150px)' }}>
                          {renderContent()}
                      </div>
                  </div>
              </div>
          );
      }


export default StoreKeeperDashboardLayout;
